"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ApiClientResponseError extends Error {
    // tslint:disable-next-line:no-any
    constructor(statusCode, response, message) {
        super(message) /* istanbul ignore next */;
        this.name = 'ApiClientResponseError';
        this.statusCode = statusCode;
        this.response = response;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
exports.ApiClientResponseError = ApiClientResponseError;



// WEBPACK FOOTER //
// ./node_modules/@soluto-private/common-event-api-client/node_modules/@soluto-private/base-client/dist/src/errors/ApiClientResponseError.js